import { LazyLoad } from 'app/utils';

export const EventFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.EventFormPage,
);
